// extracted by mini-css-extract-plugin
export default {"icon":"BellIcon_icon__+XhAS"};